import api from '../utils/axios.ts';

// Expense Management APIs
export const getExpenses = (params) => api.get('/expenses', { params });
export const getExpenseById = (id) => api.get(`/expenses/${id}`);
export const createExpense = (data) => api.post('/expenses', data);
export const updateExpense = (id, data) => api.put(`/expenses/${id}`, data);
export const deleteExpense = (id) => api.delete(`/expenses/${id}`);
export const exportExpenses = (params) => api.get('/expenses/export', { params, responseType: 'blob' });

// Context Switch API
export const switchAdminContext = (context) => api.get(`/switch-context?context=${context}`); 

// Bank Transfer Settings APIs
export const getBankTransferSettings = () => api.get('/bank-transfer/settings');
export const updateBankTransferSettings = (data: { paybill_number: string; account_number: string; is_active?: boolean }) => api.post('/bank-transfer/settings', data);